
export const CBACKGROUND_COLORS = {
DEFAULT :'#FAFDFB',
SYS_LIGHT_BACKGROUND : '#F4F6F6'
} as const;

export const CBACKGROUND_PROPERTIES = {
    BACKGROUND_COLOR: 'background-color'
} as const;